export const ARTICLES_PER_PAGE = 9;
export const TRUNCATE_LIMIT = 70;

export const CATEGORIES = [
  'all',
  'diet',
  'workouts',
  'motivation',
  'psychodietetics',
  'tips',
  'chefs-advice',
];

// for analytics purposes
export const CATEGORY_AS_NUMBER = {
  all: 0,
  diet: 1,
  workouts: 3,
  motivation: 4,
  psychodietetics: 5,
  tips: 6,
  'chefs-advice': 7,
};

// for i18n-unused
// t('feed.all')
// t('feed.excercise')
// t('feed.tips')
// t('feed.diet')
